const footerData = [
  {
    mainHeading: "Features",
    mainHeadingLink: "",
    subHeaders: [
      {
        title: "Events",
        link: "https://www.liv-cycling.com/za/events/",
        target: "_blank",
      },
      {
        title: "Find a Liv Retailer",
        link: "/store-locator",
      },
      {
        title: "News",
        link: "/news",
      },
      {
        title: "Teams & Riders",
        link: "https://www.liv-cycling.com/global/teams-and-riders",
        target: "_blank",
      },
      {
        title: "Technology",
        link: "/technology",
      },
    ],
  },
  {
    mainHeading: "Support",
    mainHeadingLink: "",
    subHeaders: [
      {
        title: "Contact",
        link: "/contact",
      },
      {
        title: "Owner's Manuals",
        link: "https://www.liv-cycling.com/global/manuals",
        target: "_blank",
      },
      // {
      //   title: "Bike Archive",
      //   link: "https://www.liv-cycling.com/za/archive",
      //   target: "_blank",
      // },
      {
        title: "Warranty",
        link: "/warranty",
      },
      {
        title: "Fitting Guide",
        link: "/fitting-guide",
      },
    ],
  },
  {
    mainHeading: "Company",
    mainHeadingLink: "",
    subHeaders: [
      {
        title: "About Liv Bicycles",
        link: "/about",
      },
      {
        title: "Cookie Policy",
        link: "/cookie",
      },
      {
        title: "Global Website",
        link: "https://www.liv-cycling.com/global",
        target: "_blank",
      },
    ],
  },
  {
    mainHeading: "Contact Us",
    mainHeadingLink: "",
    subHeaders: [
      {
        title: "Email Us",
        link: "mailto: info@dragons.co.za",
      },
      {
        title: " info@dragons.co.za",
        link: "mailto: info@dragons.co.za",
      },
      {
        title: "021 461 6252",
        link: "tel:021 461 6252",
      },
    ],
    icons: true,
  },
];

export { footerData };
